import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    header: {
        background: '#E8E8E8',
        display: 'flex',
        alignItems: 'center',
        height: '49px',
        padding: '0px 0px 0 15px',
        "& h1": {
            padding: '0px 0px 0 15px',
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '28.8px',
            color: '#2D4D95',
        }

    },
    timerwatch: {
        color: '#85888A',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        "& img": {
            height: 'unset !important',
            margin: 'auto 5px !important',
            maxWidth: '18px',
        }
    },
    paymentBox: {
        border: '1px solid #DADADA',
        minHeight: '220px',
        display: 'flex',
        background: '#FFFFFF',
        textAlign: 'center',
        borderRadius: '10px',
        marginRight: '10px',
        flexFlow: 'column',
        justifyContent: 'center',
        cursor: 'pointer',
        "& img": {
            margin: '10px auto',
            borderRadius: '50px',
            width: '70px',
            height: '70px',
        },
        "& .placeholder": {
            margin: '10px auto',
            border: '3px solid #0686d8',
            borderRadius: '50px',
            width: '70px',
            height: '70px',
            padding: '8px',
        },
        "& p": {
            margin: '5px',
            fontWeight: 700,
            fontSize: '16px',
            "& img": {
                margin: '10px auto',
                width: '30px',
                height: '30px',
            },
        },
        "& h3": {
            color: '#3C4549',
            fontSize: '24px',
            fontWeight: 800,
            margin: '7px 0',
        },
        "& h4": {
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: '0.01em',
            color: '#848789',
        },
        "& .pending": {
            fontWeight: 500,
            color: '#FE9800;'
        }
    },
    DateTime: {
        fontStyle: 'normal',
        fontWeight: '400 !important',
        fontSize: '14px !important',
        lineHeight: '16px',
        letterSpacing: '0.01em',
        color: '#848789',
        "& img": {
            margin: '0 2px',
        }
    },
    heading: {
        fontWeight: 700,
        fontSize: '20px',
        margin: '0px',
        marginTop: '7px',
        color: '#3C4549',
    },
    container: {
        padding: '6px 15px',
        "& .custom-grid img": {
            width: '25px',
            height: '25px',
            margin: '5px 5px',
            borderRadius: 0,
        },
        "& .custom-grid .placeholder": {
            margin: '5px 5px',
            border: '2px solid #0686d8',
            borderRadius: '50px',
            width: '40px',
            height: '40px',
            padding: '5px',
        },

    },
    BigButton: {
        borderRadius: '15px',
        background: 'linear-gradient(180deg, rgba(0, 73, 163, 0.3) 0%, #0049A3 100%);',
        boxShadow: '0px 4px 12px rgba(0, 73, 163, 0.3);',
        position: 'relative',
        margin: '0px 10px',
        marginBottom: '20px',
        minHeight: '250px',
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        color: 'white',
        "& h1": {
            fontSize: '80px',
            lineHeight: '100%',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: 'white',
            margin: 0,
        },
        "& h3": {
            lineHeight: '100%',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            color: 'white',
            margin: 0,
            fontSize: '32px',
        }
    },
    AddIcon: {
        "& svg": {
            color: 'white',
            fontSize: '115px',
            fontWeight: 900,
            marginRight: '0px',
        }
    },
    paper: {
        borderRadius: '15px',
        background: '#FFFFFF',
        boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.2)',
        position: 'relative',
        margin: '0px 10px',
        marginBottom: '20px',
        minHeight: '250px',
    },
    paperTop: {
        display: 'flex',
        alignItems: 'baseline',
        background: '#CEDDFF',
        borderRadius: '15px 15px 0px 0px',
        padding: '15px',
    },
    paperHeading: {
        fontSize: window.max1550 ? '19px' : '24px',
        lineHeight: '29px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        color: '#41416E',
        fontWeight: '700',
        margin: 0,
    },
    paperBottom: {
        padding: '15px 15px',
    },
    FilterArea: {
        marginLeft: 'auto',
        "& select": {
            border: '1px solid #4D80C9',
            padding: '5px',
            borderRadius: '5px',
            fontSize: '14px',
            color: '#676F80',
        },
        "& .MuiInputBase-root": {
            margin: 0,
            height: 'auto',
            minHeight: 'auto',
        }
    },
    productDetails: {

        "& p": {
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '22px',
            display: 'flex',
            alignItems: 'center',
            color: '#757575',
            margin: '10px 0',
        },
        "& span": {
            marginLeft: 'auto',
            lineHeight: '48px',
            display: 'flex',
            alignItems: 'center',
            color: '#2D4D95',
            margin: 'auto',

        },

    },
    financialBox: {
        "& p": {
            fontWeight: 700,
            fontSize: '15px',
            lineHeight: '22px',
            display: 'flex',
            alignItems: 'center',
            color: '#757575',
            margin: '10px 0',
        },
        "& h2": {
            fontWeight: 700,
            fontSize: '32px',
            lineHeight: '48px',
            display: 'flex',
            alignItems: 'center',
            color: '#2D4D95',
            margin: '6px 0',

        },
        "& img": {
            margin: '16px 0',
        }
    },


    checkBoxBtn: {
        marginLeft: "0px",
        paddingRight: "5px",
        "& + .MuiFormControlLabel-label": {
            color: "#52575C",
            fontSize: "14px",
            width: '100%',
            textAlign: 'center',
            margin: '5px',
        },
        "& .MuiSvgIcon-root": {
            opacity: 0,
            display: 'none',
        }
    },
    checkBoxFormLabel: {
        margin: '0px 2px 5px 2px',
        width: '25%',
    },
    gridHeader: {
        padding: '6px 15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        "& .HeaderText": {
            color: 'var(--accent- colors - ui - 1 -default, #3C4549)',
            fontFamily: 'Lato',
            fontSize: '19.819px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
        }
    },
    gridActions: {
        textAlign: 'right',
    },

    changeBtn: {
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#454545',
        borderRadius: '6px',
        marginRight: '5px',
        padding: '8px 16px',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff !important',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#454545',
        }
    },

    statusBoxes: {
        minHeight: '180px',
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#EDEDED',
        borderRadius: '10px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.25)',
        "& h2": {
            fontSize: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 0,
            lineHeight: 1,
        },
        "& h3": {
            fontSize: '25px',
            textAlign: 'center',
            margin: '10px 0',
        }
    },

    statusBoxContainer: {
        display: 'flex',
        marginBottom: '10px',
        width: '100%',
        flexFlow: 'wrap',
        "& .Submitted": {
            background: '#77C5F8',
            border: '1px solid transparent',
        },
        "& .Submitted:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #77C5F8 0%, #004e81 100%)',
            backgroundRepeat: 'no-repeat',
        },
        "& .Mui-checked + span > .Submitted": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #77C5F8 0%, #004e81 100%)',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
        },
        "& .Mui-checked + span > .Submitted::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },


        "& .EmailOpened": {
            background: '#7EDACB',
            border: '1px solid transparent',
        },
        "& .Mui-checked + span > .EmailOpened": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #7EDACB 0%, #006050 100%)',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
        },
        "& .Mui-checked + span > .EmailOpened::before": {
            content: "'✔'",
            fontSize: '19px',
            fontWeight: 'bolder',
            color: '#01da01',
            display: 'inline-block',
            width: '25px',
            height: '25px',
            position: 'absolute',
            background: 'white',
            right: 5,
            top: 5,
            borderRadius: '50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        },
        "& .EmailOpened:hover": {
            boxShadow: '0px 0px 5px 3px #00000021',
            backgroundImage: 'linear-gradient(180deg, #7EDACB 0%, #006050 100%)',
            backgroundRepeat: 'no-repeat',
        },

        "& .MuiCheckbox-colorPrimary": {
            position: 'absolute',
        }
    },
    checkBoxFormLabel: {
        margin: '5px 5px 5px 5px',
        width: window.isMobileView ? '27%' : '20%',
    },
    checkBoxBtn: {
        marginLeft: "0px",
        paddingRight: "5px",
        "& + .MuiFormControlLabel-label": {
            color: "#52575C",
            fontSize: "14px",
            width: '100%',
        },
        "& .MuiSvgIcon-root": {
            opacity: 0,
            display: 'none',
        }
    },
    statusBoxContent: {
        textAlign: 'center',
        "& h2": {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '32px',
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            color: 'white',
            marginRight: '9px',
        },
        "& h5": {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '25px',
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            color: 'white',
            marginRight: '9px',
        },
        "& h3": {
            color: 'white',
        },
        "& img": {
            width: '50px',
        }
    },


    avatarContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },

    circularImage: {
        borderRadius: '100%',
        width: '120px', /* Adjust the width as per your requirements */
        height: '120px' /* Adjust the height as per your requirements */
    },
    GiftIcon: {
        fill: '#757575',
    },
    SearchSec: {
        display: 'flex',
        alignItems: 'center',
    },
    Card: {
        borderRadius: "10px",
        backgroundColor: 'white',
        padding: "15px",
        flexDirection: "column",
        alignItems: "center",
        margin: "15px 0 15px 0",
        position: "relative",

        "& .CardTop": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: 'center',
            width: "100%",
            padding: "10px 10px 10px 0px",
            marginBottom: '15px',
        },
        "& .CardMain": {
            textAlign: "center",
            backgroundColor: '#F2F2F2',
        },
        "& .CardBanner": {
            position: "relative",
            width: "100%",
            height: "240px",
            maxHeight: "240px",
            minHeight: "240px",
        },
        "& .BannerImg": {
            borderRadius: "10px",
            height: "240px",
            maxHeight: "240px",
            minHeight: "240px",
        },
        "& img": {
            width: "100%",
            maxWidth: "100%",
            marginRight: "0",
        },
        "& .DetailLogo": {
            maxWidth: "24px",
            minWidth: "40px",
            maxHeight: "24px",
            position: "absolute",
            right: "0",
            top: "5px",
        },
        "& .CardHeading": {
            fontFamily: "Lato",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHight: "16px;",
            letterSpacing: "0.24px",
            marginBottom: "20px",
        },
        "& .CardBody": {
            color: "#424242",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            maxWidth: "100%",

            textAlign: "center",
            fontFamily: "Lato",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "16px",
            letterSpacing: "0.14px",
            marginBottom: "20px",
        },
        "& .CardLogo": {
            width: "137px",
            minWidth: "137px",
            height: "35.773px",
            marginBottom: "20px",
        },

    },
    GridHeading: {
        color: '#3C4549',
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '16px',
        letterSpacing: '0.24px',
    },
    companyCard: {
        padding: "20px",
        border: "1px dashed black",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: 'white',
        textAlign: 'center',
        "& .CompanyName": {
            color: '#000',
            textAlign: 'center',
            fontFamily: 'Lato',
            fontSize: '21px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '16px',
            marginTop: '10px',
            letterSpacing: '0.21px',
        },
        "& .companyLogo": {
            border: "1px solid black",
            borderRadius: "100%",
            width: "135px",
            height: "135px",
            textAlign: "center"
        },

    },
    rightSide: {
        padding: "15px",
        "& .rating": {
            display: "flex",
            alignItems: "center",
            gap: "5px"
        },

        "& .frame": {
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            fontWeight: 600,
            margin: "15px 0px",
            color: "rgba(60, 69, 73, 0.8)",

            "& img": {
                marginTop: '3px',
                width: '4.5%',
            }
        }
    },
    CardBg: {
        background: '#F2F2F2',
        padding: '20px',
        borderRadius: '8px',
        display: 'flex', 
        alignItems: 'center',
    },
    // ProgramImg:{
    //     height:'210px',
    // },
    ProgramTitle: {
        color: '#141313',
        fontFamily: 'Lato',
        fontSize: '27px',
        fontStyle: 'normal',
        fontWeight: '400',
        letterSpacing: '0.27px',
    },
    ProgramDetails:{
        color: '#424242',
        fontFamily: 'Lato',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '22px',
        letterSpacing: '0.16px',
    },
    DisAmount: {
        color: 'var(--accent-colors-ui-1-default, #3C4549)',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '16px',
        letterSpacing: '0.18px',
        float: 'right',
        "& span": {
            color: '#19B000'
        },
    }


}));